import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer'
import '../css/index.css';

export default function Home() {
    return (
        <>
            <Navigation />
            <div className='container'>
            <div className="banner-container">
                <div className="effect-3d">
                    <iframe title='frame1' src='https://my.spline.design/chips-330b71e65aa27cf080d5851e6df1f538/' frameborder='0' width="100%" height='100%' id="myAnimation"></iframe>
                    <div width="100%" className="shadow"></div>
                </div>
                <div className="text">
                    <span>Professional Web Development & 3D Design Services in Jharsuguda, Odisha</span>
                    <span className="sm">Transform Your Digital Presence with Expert Full Stack Web Development & Stunning 3D Designs</span>

                </div>
            </div>

                <div className="article">
                    <div className="button-container">
                        <span className="button outline">Services I am currently offering</span>
                    </div>

                    <div className="article-container">
                        <div className="content-box outline">
                            <h3>Full Stack Web Development</h3>
                            <ul>
                                <li>Responsive Website Design (Works on all devices)</li>
                                <li>E-Commerce & Business Websites</li>
                                <li>Custom Web Applications (React.js, Node.js, MongoDB)</li>
                                <li>SEO-Friendly Websites (Better Google Rankings)</li>
                                <li>Website Maintenance & Optimization</li>
                            </ul>
                        </div>
                        <div className="content-box outline">
                            <h3>3D Graphic Design & Dynamic Posters</h3>
                            <ul>
                                <li>3D Product Modeling & Rendering (For E-commerce & Ads)</li>
                                <li>Architectural & Interior 3D Visualization</li>
                                <li>Promotional Posters & Social Media Banners</li>
                                <li>Logo Design & Branding</li>
                                <li>Motion Graphics & Animated Ads</li>
                            </ul>
                        </div>
                        <div className="content-box outline">
                            <h3>3D Graphic Design & Dynamic Posters</h3>
                            <ul>
                                <li>✅ Local Expertise – Based in Jharsuguda, I understand the market needs.</li>
                                <li>✅ Fast & Reliable Delivery – On-time project completion.</li>
                                <li>✅ Affordable Pricing – High-quality work at competitive rates.</li>
                                <li>✅ Client-Centric Approach – Customized solutions for your business.</li>
                            </ul>
                        </div>
                        <div className="content-box outline">
                            <h3>I provide web development and design services in:</h3>
                            <ul>
                                <li>Jharsuguda</li>
                                <li>Sambalpur</li>
                                <li>Rourkela</li>
                                <li>Bargarh</li>
                                <li>Sundargarh</li>
                                <li>And all over India & remotely</li>
                            </ul>
                        </div>
                    </div>
                </div>
           </div>
            <Footer />
        </>
    );
}